import { createRootRoute, createRoute, Outlet, redirect } from '@tanstack/react-router';

import { authRepository, meRepository } from '@web/data/repositories';
import { NoOrgPage } from '@web/ui/auth/views';

export const rootRoute = createRootRoute({
  component: () => <Outlet />,
});

export const protectedRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'protected',
  component: () => <Outlet />,
  beforeLoad: async ({ location }) => {
    const token = await authRepository.getAccessToken();
    if (!token) {
      redirect({ throw: true, to: '/login', search: { returnTo: location.href } });
    }
  },
});

/**
 * `/` is the post-login fan-out. With the org-switcher gone the user is
 * always pinned to their first org membership.
 *   - 0 orgs → `/no-org` (terminal page, no redirect loop)
 *   - 1+ orgs → `/orgs/<first-slug>/overview`
 */
export const indexRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: '/',
  beforeLoad: async () => {
    const me = await meRepository.getMe();
    const [org] = me.orgs;
    if (!org) {
      redirect({ throw: true, to: '/no-org' });
      return;
    }
    redirect({
      throw: true,
      to: '/orgs/$orgSlug/overview',
      params: { orgSlug: org.slug },
    });
  },
});

export const noOrgRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: '/no-org',
  component: NoOrgPage,
});
